import PropTypes from 'prop-types';
import { useState } from 'react';
import { Box, Button, Flex } from '@chakra-ui/react';

import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

import reactQuillOptions from 'utils/constants/reactQuillOptions';

import ConfirmationActionModal from 'components/common/modals/ConfirmationActionModal';

import 'react-quill/dist/quill.snow.css';
import './styles/QuillContentStyling.css';

function NarrativeSubQuest({
  classId,
  course,
  quest,
  subQuest,
  code,
  onComplete,
  onPostProgression,
}) {
  const [showModal, setShowModal] = useState(false);
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState(null);

  const sanitizedContent = DOMPurify.sanitize(
    subQuest.subQuestNarrative.content,
    reactQuillOptions
  );

  const handleConfirm = async () => {
    try {
      setStatus('loading');
      if (onPostProgression) {
        await onPostProgression({
          courseId: course.id,
          questId: quest.id,
          subQuestId: subQuest.id,
          classId,
          code,
        });
      }
      setStatus('succeeded');
      if (onComplete) {
        onComplete();
      }
    } catch (err) {
      setError(err);
      setStatus('failed');
    }
  };

  return (
    <Box className="narrative-container">
      <Box className="narrative-content">{parse(sanitizedContent)}</Box>
      <Flex justifyContent="flex-end" pe={10} py={5}>
        <Button
          size="md"
          colorScheme="red"
          variant="solid"
          width="160px"
          onClick={() => setShowModal(true)}
        >
          Mark as Complete
        </Button>
      </Flex>

      <ConfirmationActionModal
        isVisible={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleConfirm}
        onSubmitResult={() => {
          setShowModal(false);
          setStatus('idle');
          setError(null);
        }}
        status={status}
        description="By confirming below, you acknowledge that you have read all contents of this activity in full. Once confirmed, this activity will be marked as completed."
        successMessage="Congratulations on completing this narrative sub-quest!"
        error={error}
      />
    </Box>
  );
}

NarrativeSubQuest.defaultProps = {
  classId: null,
  onComplete: null,
  onPostProgression: null,
};

NarrativeSubQuest.propTypes = {
  classId: PropTypes.number,
  subQuest: PropTypes.object.isRequired,
  course: PropTypes.object.isRequired,
  quest: PropTypes.object.isRequired,
  code: PropTypes.string.isRequired,
  onComplete: PropTypes.func,
  onPostProgression: PropTypes.func,
};

export default NarrativeSubQuest;
